import cnContent from "./token/fr/cn.js";
import usContent from "./token/fr/us.js";
import jpContent from "./token/fr/jp.js";
import koContent from "./token/fr/ko.js";
import geContent from "./token/fr/ge.js";
import ukContent from "./token/fr/uk.js";
import uaeContent from "./token/fr/uae.js";
import frContent from "./token/fr/fr.js";
import sgContent from "./token/fr/sg.js";

import agreementContent from "./agreement/fr-fr.js";

export default {
  "head.index": "Accueil",
  "head.product": "Produits",
  "head.computeProduct": "Produits de puissance de calcul",
  "head.computeProductDesc":
    "Acheter de la puissance de calcul et obtenir des rendements mondiaux",
  "head.rentalProduct": "Produits de location",
  "head.rentalProductDesc":
    "Louer des serveurs haute performance pour des rendements stables",
  "head.rental": "Location",
  "head.about": "À propos",

  // ===== Menu déroulant utilisateur =====
  "menu.profile": "Profil",
  "menu.security": "Sécurité du compte",
  "menu.settings": "Paramètres",
  "menu.products": "Mes produits",
  "menu.deposits": "Historique des dépôts",
  "menu.withdraws": "Historique des retraits",
  "menu.walletLog": "Historique des transactions",
  "menu.logout": "Se déconnecter",
  "menu.logoutSuccess": "Déconnexion réussie",

  // ===== Pied de page =====
  "footer.contactEmail": "E-mail de contact",

  // ===== Page d'accueil =====
  "home.heroTitle1": "Seigneur mondial de la nouvelle puissance de calcul",
  "home.heroTitle2": "Moteur d'actifs à double entraînement",
  "home.heroDesc":
    "La plateforme privilégie les sites matures pré-réservés pour la location par les géants de l'IA comme Microsoft, OpenAI et DeepSeek",
  "home.heroBtn":
    "Sécuriser les rendements de puissance de calcul maintenant →",
  "home.statTrade": "Volume de transactions quotidien",
  "home.statTradeValue": "1Md+",
  "home.statReliability": "Fiabilité",
  "home.statGlobal": "Service mondial",
  "home.buildTitle1": "Construisez votre",
  "home.buildTitle2": "Centre de données exclusif",
  "home.buildDesc1":
    "Gestion indépendante · Location indépendante · Rendements transparents — Nous nous occupons uniquement de l'exploitation,",
  "home.buildDesc2": "Tous les rendements appartiennent au constructeur",
  "home.buildFeature1Title": "Gestion indépendante",
  "home.buildFeature1Desc":
    "Vous avez un contrôle total sur votre centre de données et décidez des stratégies de location et des prix",
  "home.buildFeature2Title": "Rendements transparents",
  "home.buildFeature2Desc":
    "Visualisation des données financières en temps réel, chaque rendement est clairement traçable",
  "home.buildFeature3Title": "Exploitation professionnelle",
  "home.buildFeature3Desc":
    "Nous prenons en charge la maintenance matérielle, le support réseau et le support technique 7×24",
  "home.buildFeature4Title": "Tous les rendements vous appartiennent",
  "home.buildFeature4Desc":
    "Après déduction des coûts d'exploitation de base, tous les rendements de location appartiennent au constructeur",
  "home.buildBtn": "Construire maintenant →",
  "home.buildStatsTitle": "📈 Aperçu des rendements de construction",
  "home.buildStatsUpdate": "Mise à jour en temps réel",
  "home.buildStatRooms": "Centres de données construits",
  "home.buildStatServers": "Serveurs en cours d'exécution",
  "home.buildStatProfit": "Rendements totaux des constructeurs",
  "home.buildStatPayback": "Période de récupération moyenne",
  "home.buildStatMonth": "Mois",
  "home.buildCta":
    "🎯 Rejoignez maintenant et lancez votre activité d'infrastructure de calcul",
  "home.buildCtaBtn": "En savoir plus",
  "home.featuresBadge": "✦ Avantages clés",
  "home.featuresTitle1": "Pourquoi",
  "home.featuresTitle2": "AETRIVOL",
  "home.feature1Title": "Efficace et pratique",
  "home.feature1Desc":
    "AETRIVOL utilise ses avantages pour donner aux particuliers accès aux dividendes de l'ère de la puissance de calcul",
  "home.feature2Title": "Sécurité nationale",
  "home.feature2Desc":
    "Protection réseau multicouche, transmission de données chiffrée, surveillance de sécurité 7×24",
  "home.feature3Title": "Matériel haute performance",
  "home.feature3Desc":
    "Dernière génération de GPU NVIDIA avec stockage NVMe haute vitesse et RAM DDR5",
  "home.feature4Title": "Nœuds mondiaux",
  "home.feature4Desc":
    "Couverture des centres de données en Asie-Pacifique, Europe et Amérique du Nord avec accélération mondiale à faible latence",
  "home.appBadge": "📱 Mobile",
  "home.appTitle": "Bientôt disponible",
  "home.appDesc1": "L'application mobile AETRIVOL bientôt disponible,",
  "home.appDesc2":
    "Restez informé des tendances du marché de la puissance de calcul à tout moment,",
  "home.appDesc3": "Gérez votre puissance de calcul GPU en un clic.",
  "home.appQrText": "Scannez pour télécharger",
  "home.appStore": "App Store",
  "home.googlePlay": "Google Play",
  "home.walletsTitle1": "Partenaires",
  "home.walletsTitle2": "Portefeuilles",
  "home.walletsDesc":
    "Connectez vos portefeuilles de confiance et gérez vos actifs en toute sécurité",
  "home.settleTitle1": "Mises à jour de",
  "home.settleTitle2": "règlement en temps réel",
  "home.settleDesc":
    "Règlement des rendements en temps réel pour les utilisateurs mondiaux",
  "home.modalTitle": "Bientôt disponible",
  "home.modalDesc1":
    "Aucun nouveau projet de centre de données disponible actuellement",
  "home.modalDesc2": "Merci pour votre attention et votre soutien !",
  "home.modalBtn": "Compris",

  // ===== Page d'accueil - Pays de puissance de calcul =====
  "tokenList.title1": "Choisissez votre",
  "tokenList.title2": "pays de puissance de calcul",
  "tokenList.desc":
    "Pays leaders mondiaux en puissance de calcul, faible investissement, rendements élevés",
  "tokenList.buy": "Acheter maintenant",
  "tokenList.more": "Plus de produits",
  "tokenList.tagHot": "🔥 Populaire",
  "tokenList.tagProfit": "💰 Rendement élevé",
  "tokenList.tagRecommend": "⭐ Recommandé",
  "tokenList.tagNew": "🆕 Nouveau",

  // ===== Page d'accueil - Location de serveurs =====
  "serverList.title1": "Location de",
  "serverList.title2": "serveurs",
  "serverList.desc":
    "Serveurs haute performance matures pour des rendements de location supérieurs",
  "serverList.dailyIncome": "Revenu quotidien",
  "serverList.value": "Valeur du serveur",
  "serverList.yield": "Rendement",
  "serverList.gpu": "GPU",
  "serverList.vram": "VRAM",
  "serverList.storage": "Stockage",
  "serverList.status": "Statut",
  "serverList.available": "✅ Disponible",
  "serverList.full": "⏳ Complet",
  "serverList.countdown": "Démarre dans",
  "serverList.days": "jours",
  "serverList.btnFull": "Complet",
  "serverList.btnRent": "Louer maintenant →",
  "serverList.btnWait": "En attente de démarrage",
  "serverList.look": "Voir les détails",
  "serverList.btnEnded": "Terminé",
  "serverList.more": "Voir plus de produits",
  "serverList.spec1": "Entrée de gamme",
  "serverList.spec2": "Léger",
  "serverList.spec3": "Performance",
  "serverList.spec4": "Flagship",
  "serverList.tagHot": "🔥 Populaire",
  "serverList.tagRecommend": "⭐ Recommandé",
  "serverList.tagNew": "🌟 Nouveau",

  // ===== Page d'accueil - Carrousel de règlement =====
  "settle.amount": "Montant du règlement",
  "settle.status": "Réglé",
  "settle.power": "Valeur de puissance de calcul",
  "settle.rental": "Location de serveur",
  "settle.basic": "Rendements de base",
  "settle.cycle": "Rendements de cycle",
  "settle.phase1": "Phase 1",
  "settle.phase2": "Phase 2",
  "settle.phase3": "Phase 3",
  "settle.phase4": "Phase 4",

  // ===== Centre membre =====
  "member.recharge": "Dépôt",
  "member.withdraw": "Retrait",
  "member.tabProducts": "Mes produits",
  "member.tabHistory": "Historique",
  "member.tabWalletLog": "Enregistrements du portefeuille",
  "member.tabDeposits": "Historique des dépôts",
  "member.tabWithdraws": "Historique des retraits",
  "member.tabAddresses": "Adresses de retrait",
  "member.avatarAlt": "Avatar utilisateur",
  "member.settingsTitle": "Paramètres",
  "member.logoutTitle": "Se déconnecter",
  "member.tabTokenProduct": "Produits de puissance de calcul",
  "member.tabRentProduct": "Produits de location",

  // ===== Page de paramètres =====
  "setting.back": "Retour",
  "setting.title": "⚙️ Paramètres",
  "setting.menuProfile": "Profil",
  "setting.menuSecurity": "Sécurité du compte",
  "setting.menuVerify": "Vérification du compte",
  "setting.menuChangePwd": "Changer le mot de passe",
  "setting.menuTradePwd": "Mot de passe de trading",
  "setting.getUserInfoFail":
    "Impossible de récupérer les informations utilisateur",

  // ===== Paramètres - Profil =====
  "profile.title": "Profil",
  "profile.subtitle": "Gérez vos informations de base",
  "profile.avatar": "Avatar",
  "profile.avatarAlt": "Avatar",
  "profile.changeAvatar": "Changer l'avatar",
  "profile.systemAvatar": "Avatar système",
  "profile.firstName": "Prénom",
  "profile.firstNamePlaceholder": "Entrez votre prénom",
  "profile.lastName": "Nom",
  "profile.lastNamePlaceholder": "Entrez votre nom",
  "profile.phone": "Téléphone",
  "profile.phonePlaceholder": "Entrez votre numéro de téléphone",
  "profile.address": "Adresse",
  "profile.addressPlaceholder": "Entrez votre adresse",
  "profile.saving": "Enregistrement...",
  "profile.saveInfo": "Enregistrer les informations",
  "profile.selectSystemAvatar": "Sélectionner un avatar système",
  "profile.avatarAltNum": "Avatar {count}",
  "profile.selectImageFile": "Veuillez sélectionner un fichier image",
  "profile.imageTooLarge": "La taille de l'image ne doit pas dépasser 5 Mo",
  "profile.uploadFail": "Échec du téléchargement",
  "profile.updateFail": "Échec de la mise à jour",
  "profile.updateSuccess": "Mise à jour réussie",
  "profile.uploadFailNoPath":
    "Échec du téléchargement, aucune URL d'image reçue",
  "profile.uploadFailRetry":
    "Échec du téléchargement, veuillez réessayer plus tard",
  "profile.saveFail": "Échec de l'enregistrement",
  "profile.saveSuccess": "Enregistrement réussi",
  "profile.saveFailRetry":
    "Échec de l'enregistrement, veuillez réessayer plus tard",

  // ===== Paramètres - Vérification =====
  "verifyPanel.title": "Vérification du compte",
  "verifyPanel.subtitle":
    "Augmentez les autorisations du compte et le niveau de confiance",
  "verifyPanel.realName": "Vérification du nom réel",
  "verifyPanel.realNameDesc":
    "Vous avez soumis vos informations de vérification du nom réel",
  "verifyPanel.verified": "Vérifié ✓",
  "verifyPanel.goVerify": "Vérifier maintenant →",

  // ===== Paramètres - Sécurité du compte =====
  "securityPanel.title": "Sécurité du compte",
  "securityPanel.subtitle": "Protégez la sécurité de votre compte",
  "securityPanel.phoneBind": "Liaison téléphonique",
  "securityPanel.phoneBound": "Lié {phone}",
  "securityPanel.notBound": "Non lié",
  "securityPanel.emailBind": "Liaison e-mail",
  "securityPanel.emailBound": "Lié {email}",
  "securityPanel.twofa": "Authentification à deux facteurs (2FA)",
  "securityPanel.twofaOn": "Activé · Code dynamique requis à chaque connexion",
  "securityPanel.twofaOff": "Désactivé · Recommandé pour une sécurité accrue",
  "securityPanel.twofaEnabled": "Activé ✓",
  "securityPanel.enableTwofa": "Activer la 2FA",
  "securityPanel.disableTwofaTitle": "Désactiver la 2FA",
  "securityPanel.enableTwofaTitle": "Activer la 2FA",
  "securityPanel.qrAlt": "Code QR 2FA",
  "securityPanel.tip1":
    "1. Téléchargez Google Authenticator ou Microsoft Authenticator",
  "securityPanel.tip2":
    "2. Scannez le code QR ci-dessus ou entrez la clé secrète",
  "securityPanel.copy": "Copier",
  "securityPanel.verifyCode": "Code de vérification",
  "securityPanel.verifyCodePlaceholder":
    "Entrez le code dynamique à 6 chiffres",
  "securityPanel.emailCode": "Code e-mail",
  "securityPanel.emailCodePlaceholder": "Entrez le code de vérification e-mail",
  "securityPanel.resend": "Renvoyer dans {count}s",
  "securityPanel.sendCode": "Envoyer le code",
  "securityPanel.disableWarning1":
    "Après la désactivation de la 2FA, votre compte perdra une protection de sécurité supplémentaire.",
  "securityPanel.disableWarning2":
    "Veuillez confirmer que vous souhaitez désactiver la 2FA.",
  "securityPanel.cancel": "Annuler",
  "securityPanel.confirmDisable": "Confirmer la désactivation",
  "securityPanel.confirmEnable": "Confirmer l'activation",
  "securityPanel.getSecretFail": "Impossible de récupérer la clé secrète",
  "securityPanel.copySuccess": "Clé secrète copiée dans le presse-papiers",
  "securityPanel.copyFail": "Impossible de copier la clé secrète",
  "securityPanel.enterVerifyCode":
    "Veuillez entrer le code dynamique à 6 chiffres",
  "securityPanel.operationFail": "Échec de l'opération",
  "securityPanel.twofaEnabledMsg": "La 2FA a été activée !",
  "securityPanel.twofaDisabledMsg": "La 2FA a été désactivée !",
  "securityPanel.enterEmailCode":
    "Veuillez entrer le code de vérification e-mail",

  // ===== Paramètres - Changer le mot de passe =====
  "changePwd.title": "Changer le mot de passe",
  "changePwd.subtitle":
    "Changez votre mot de passe régulièrement pour protéger votre compte",
  "changePwd.warning":
    "Vous n'avez pas activé la 2FA et ne pouvez pas changer votre mot de passe. Veuillez d'abord activer la 2FA.",
  "changePwd.goEnable": "Activer maintenant",
  "changePwd.newPwd": "Nouveau mot de passe",
  "changePwd.newPwdPlaceholder":
    "Entrez le nouveau mot de passe (au moins 6 caractères)",
  "changePwd.confirmPwd": "Confirmer le nouveau mot de passe",
  "changePwd.confirmPwdPlaceholder": "Rentrez le nouveau mot de passe",
  "changePwd.emailCode": "Code e-mail",
  "changePwd.emailCodePlaceholder": "Entrez le code de vérification e-mail",
  "changePwd.resend": "Renvoyer dans {count}s",
  "changePwd.sendCode": "Envoyer le code",
  "changePwd.confirmBtn": "Confirmer le changement",
  "changePwd.twofaDesc":
    "Entrez votre code 2FA pour envoyer le code de vérification e-mail",
  "changePwd.pwdTooShort":
    "Le nouveau mot de passe doit contenir au moins 6 caractères",
  "changePwd.pwdMismatch":
    "Les deux nouveaux mots de passe ne correspondent pas",
  "changePwd.enableTwofaFirst":
    "Veuillez activer la 2FA avant de changer votre mot de passe",
  "changePwd.codeError": "Erreur de code de vérification",
  "changePwd.enterEmailCode": "Veuillez entrer le code de vérification e-mail",
  "changePwd.success":
    "Mot de passe changé avec succès ! Veuillez vous reconnecter",

  // ===== Paramètres - Mot de passe de trading =====
  "tradePwd.title": "Mot de passe de trading",
  "tradePwd.subtitle": "Protégez la sécurité de vos actifs",
  "tradePwd.warning":
    "Vous n'avez pas activé la 2FA et ne pouvez pas changer votre mot de passe de trading. Veuillez d'abord activer la 2FA.",
  "tradePwd.goEnable": "Activer maintenant",
  "tradePwd.newPwd": "Nouveau mot de passe de trading",
  "tradePwd.newPwdPlaceholder":
    "Entrez le nouveau mot de passe de trading (au moins 6 caractères)",
  "tradePwd.confirmPwd": "Confirmer le mot de passe de trading",
  "tradePwd.confirmPwdPlaceholder":
    "Rentrez le nouveau mot de passe de trading",
  "tradePwd.emailCode": "Code e-mail",
  "tradePwd.emailCodePlaceholder": "Entrez le code de vérification e-mail",
  "tradePwd.resend": "Renvoyer dans {count}s",
  "tradePwd.sendCode": "Envoyer le code",
  "tradePwd.confirmBtn": "Confirmer le changement",
  "tradePwd.twofaDesc":
    "Entrez votre code 2FA pour envoyer le code de vérification e-mail",
  "tradePwd.pwdTooShort":
    "Le nouveau mot de passe de trading doit contenir au moins 6 caractères",
  "tradePwd.pwdMismatch":
    "Les deux mots de passe de trading ne correspondent pas",
  "tradePwd.enableTwofaFirst":
    "Veuillez activer la 2FA avant de changer votre mot de passe de trading",
  "tradePwd.codeError": "Erreur de code de vérification",
  "tradePwd.enterEmailCode": "Veuillez entrer le code de vérification e-mail",
  "tradePwd.success": "Mot de passe de trading changé avec succès !",

  // ===== Centre membre - Historique =====
  "history.tabToken": "Enregistrements de puissance de calcul",
  "history.tabRent": "Enregistrements de location",

  // ===== Centre membre - Historique de puissance de calcul =====
  "historyToken.type": "Type",
  "historyToken.allType": "Tous les types",
  "historyToken.buy": "Achat",
  "historyToken.income": "Revenu",
  "historyToken.reset": "Réinitialiser",
  "historyToken.loading": "Chargement...",
  "historyToken.empty": "Aucun produit",
  "historyToken.date": "Date",
  "historyToken.product": "Produit",
  "historyToken.quantity": "Quantité",
  "historyToken.amount": "Montant",
  "historyToken.fee": "Frais",
  "historyToken.total": "Total",
  "historyToken.time": "Heure",
  "historyToken.profit": "Gain/Perte",
  "historyToken.deduct": "Déduction",
  "historyToken.profitPositive": "Gain",
  "historyToken.profitNegative": "Perte",
  "historyToken.unknownStatus": "Statut inconnu",
  "historyToken.paginationInfo":
    "Total {total} entrées, page {page} / {totalPages}",
  "historyToken.firstPage": "Première",
  "historyToken.prevPage": "Précédent",
  "historyToken.nextPage": "Suivant",
  "historyToken.lastPage": "Dernière",
  "historyToken.perPage": "{count}/page",

  // ===== Centre membre - Historique de location =====
  "historyServer.type": "Type",
  "historyServer.allType": "Tous les types",
  "historyServer.buy": "Achat",
  "historyServer.income": "Revenu",
  "historyServer.reset": "Réinitialiser",
  "historyServer.loading": "Chargement...",
  "historyServer.empty": "Aucun produit",
  "historyServer.date": "Date",
  "historyServer.product": "Produit",
  "historyServer.share": "Part",
  "historyServer.amount": "Montant",
  "historyServer.fee": "Frais",
  "historyServer.total": "Total",
  "historyServer.time": "Heure",
  "historyServer.unknownStatus": "Statut inconnu",
  "historyServer.paginationInfo":
    "Total {total} entrées, page {page} / {totalPages}",
  "historyServer.firstPage": "Première",
  "historyServer.prevPage": "Précédent",
  "historyServer.nextPage": "Suivant",
  "historyServer.lastPage": "Dernière",
  "historyServer.perPage": "{count}/page",

  // ===== Centre membre - Historique des dépôts =====
  "deposit.loading": "Chargement...",
  "deposit.empty": "Aucun enregistrement de dépôt",
  "deposit.coin": "Pièce",
  "deposit.quantity": "Quantité",
  "deposit.network": "Réseau",
  "deposit.address": "Adresse",
  "deposit.status": "Statut",
  "deposit.time": "Heure",
  "deposit.success": "Réussi",
  "deposit.processing": "Traitement",
  "deposit.paginationInfo": "Total {total} entrées, page {page} / {totalPages}",
  "deposit.firstPage": "Première",
  "deposit.prevPage": "Précédent",
  "deposit.nextPage": "Suivant",
  "deposit.lastPage": "Dernière",
  "deposit.perPage": "{count}/page",

  // ===== Centre membre - Historique des retraits =====
  "withdrawal.loading": "Chargement...",
  "withdrawal.empty": "Aucun enregistrement de retrait",
  "withdrawal.coin": "Pièce",
  "withdrawal.quantity": "Quantité",
  "withdrawal.network": "Réseau",
  "withdrawal.address": "Adresse",
  "withdrawal.status": "Statut",
  "withdrawal.time": "Heure",
  "withdrawal.statusProcessing": "Traitement",
  "withdrawal.statusSuccess": "Réussi",
  "withdrawal.statusFailed": "Échec",
  "withdrawal.statusUnknown": "Inconnu",
  "withdrawal.paginationInfo":
    "Total {total} entrées, page {page} / {totalPages}",
  "withdrawal.firstPage": "Première",
  "withdrawal.prevPage": "Précédent",
  "withdrawal.nextPage": "Suivant",
  "withdrawal.lastPage": "Dernière",
  "withdrawal.perPage": "{count}/page",

  // ===== Centre membre - Adresses de retrait =====
  "addresse.title": "Adresses de retrait",
  "addresse.addAddress": "+ Ajouter une adresse",
  "addresse.loading": "Chargement...",
  "addresse.empty": "Aucune adresse de retrait",
  "addresse.coin": "Pièce",
  "addresse.network": "Réseau",
  "addresse.address": "Adresse",
  "addresse.time": "Heure",
  "addresse.action": "Action",
  "addresse.delete": "Supprimer",
  "addresse.deleteConfirm":
    "Êtes-vous sûr de vouloir supprimer cette adresse de retrait ? Cette action est irréversible.",
  "addresse.cancel": "Annuler",
  "addresse.confirmDelete": "Confirmer la suppression",
  "addresse.deleteSuccess": "Supprimé avec succès",
  "addresse.paginationInfo":
    "Total {total} entrées, page {page} / {totalPages}",
  "addresse.firstPage": "Première",
  "addresse.prevPage": "Précédent",
  "addresse.nextPage": "Suivant",
  "addresse.lastPage": "Dernière",
  "addresse.perPage": "{count}/page",

  // ===== Centre membre - Enregistrements du portefeuille =====
  "walletLog.type": "Type",
  "walletLog.allType": "Tous les types",
  "walletLog.reset": "Réinitialiser",
  "walletLog.loading": "Chargement...",
  "walletLog.empty": "Aucun produit",
  "walletLog.project": "Projet",
  "walletLog.amount": "Montant",
  "walletLog.time": "Heure",
  "walletLog.day": "jours",
  "walletLog.paginationInfo":
    "Total {total} entrées, page {page} / {totalPages}",
  "walletLog.firstPage": "Première",
  "walletLog.prevPage": "Précédent",
  "walletLog.nextPage": "Suivant",
  "walletLog.lastPage": "Dernière",
  "walletLog.perPage": "{count}/page",
  "walletLog.typeDeposit": "Dépôt",
  "walletLog.typeWithdraw": "Retrait",
  "walletLog.typePay": "Paiement",
  "walletLog.typeTokenIncome": "Gain de puissance de calcul",
  "walletLog.typeTokenLoss": "Perte de puissance de calcul",
  "walletLog.typeServerIncome": "Revenu serveur",
  "walletLog.typeTransferReturn": "Retour de retrait",
  "walletLog.typeFreezeBuy": "(Achat) Gelé",
  "walletLog.typeServerRent": "Location de serveur",
  "walletLog.typeUnfreeze": "(Expiré) Dégelé",
  "walletLog.typeCompute": "Puissance de calcul",
  "walletLog.typeRent": "Location",
  "walletLog.statusUnknown": "Statut inconnu",
  "walletLog.titlePower": "Puissance de calcul",
  "walletLog.titleRent": "Location",
  "walletLog.statusDeposit": "Dépôt",
  "walletLog.statusWithdrawal": "Retrait",
  "walletLog.statusPay": "Paiement",
  "walletLog.statusPowerProfit": "Gain de puissance de calcul",
  "walletLog.statusPowerLoss": "Perte de puissance de calcul",
  "walletLog.statusServerIncome": "Revenu serveur",
  "walletLog.statusWithdrawalReturn": "Retour de retrait",
  "walletLog.statusPurchaseFreeze": "(Achat) Gelé",
  "walletLog.statusServerRent": "Location de serveur",
  "walletLog.statusExpireUnfreeze": "(Expiré) Dégelé",

  // ===== Centre membre - Aperçu des actifs =====
  "memberBox.assetOverview": "Aperçu des actifs",
  "memberBox.realTime": "Mise à jour en temps réel",
  "memberBox.totalAssets": "Actifs totaux",
  "memberBox.vsYesterday": "vs. Hier",
  "memberBox.availableBalance": "Solde disponible",
  "memberBox.frozenFunds": "Fonds gelés",
  "memberBox.incomeTrend": "Tendance des revenus",
  "memberBox.hashIncome": "Revenu de puissance de calcul",
  "memberBox.leaseIncome": "Revenu de location",
  "memberBox.hashIncomeTotal": "Revenu total de puissance de calcul",
  "memberBox.leaseIncomeTotal": "Revenu total de location",
  "memberBox.totalIncome": "Revenu total",
  "memberBox.vsLastDay": "vs. Dernier jour",
  "memberBox.time7d": "7J",
  "memberBox.time15d": "15J",
  "memberBox.time30d": "30J",

  // ===== Centre membre - Liste des produits =====
  "productToken.region": "Région",
  "productToken.allRegion": "Toutes les régions",
  "productToken.status": "Statut",
  "productToken.allStatus": "Tous les statuts",
  "productToken.statusActive": "Actif",
  "productToken.statusCompleted": "Terminé",
  "productToken.statusFrozen": "Gelé",
  "productToken.statusUnknown": "Statut inconnu",
  "productToken.reset": "Réinitialiser",
  "productToken.loading": "Chargement...",
  "productToken.empty": "Aucun produit",
  "productToken.quantity": "Quantité",
  "productToken.period": "Période",
  "productToken.latestProfit": "Dernier G/P",
  "productToken.settledProfit": "G/P réglé",
  "productToken.periodProfit": "G/P de période",
  "productToken.totalProfit": "G/P total",
  "productToken.action": "Action",
  "productToken.view": "Voir",
  "productToken.day": "jours",
  "productToken.paginationInfo":
    "Total {total} entrées, page {page} / {totalPages}",
  "productToken.firstPage": "Première",
  "productToken.prevPage": "Précédent",
  "productToken.nextPage": "Suivant",
  "productToken.lastPage": "Dernière",
  "productToken.perPage": "{count}/page",
  "productToken.detailTitle": "Détails du produit",
  "productToken.productCode": "Code produit",
  "productToken.orderCode": "Numéro de commande",
  "productToken.orderName": "Nom du produit",
  "productToken.tradeInfo": "Info de transaction",
  "productToken.tradeTime": "Heure de transaction",
  "productToken.buyPrice": "Prix d'achat",
  "productToken.principal": "Capital",
  "productToken.fee": "Frais",
  "productToken.latestPrice": "Prix actuel",
  "productToken.profitInfo": "Info G/P",
  "productToken.estimatedProfit": "G/P total estimé",
  "productToken.remark": "Remarque",
  "productToken.close": "Fermer",

  // ===== Centre membre - Liste des produits serveur =====
  "productServer.region": "Région",
  "productServer.allRegion": "Toutes les régions",
  "productServer.status": "Statut",
  "productServer.allStatus": "Tous les statuts",
  "productServer.statusActive": "Actif",
  "productServer.statusCompleted": "Terminé",
  "productServer.statusFrozen": "Gelé",
  "productServer.statusUnknown": "Statut inconnu",
  "productServer.reset": "Réinitialiser",
  "productServer.loading": "Chargement...",
  "productServer.empty": "Aucun produit",
  "productServer.productName": "Nom du produit",
  "productServer.share": "Part",
  "productServer.countdown": "Compte à rebours",
  "productServer.unsettledIncome": "Revenu non réglé",
  "productServer.settled": "Réglé",
  "productServer.totalIncome": "Revenu total",
  "productServer.action": "Action",
  "productServer.view": "Voir",
  "productServer.day": "jours",
  "productServer.paginationInfo":
    "Total {total} entrées, page {page} / {totalPages}",
  "productServer.firstPage": "Première",
  "productServer.prevPage": "Précédent",
  "productServer.nextPage": "Suivant",
  "productServer.lastPage": "Dernière",
  "productServer.perPage": "{count}/page",
  "productServer.detailTitle": "Détails du produit",
  "productServer.productCode": "Code produit",
  "productServer.orderCode": "Numéro de commande",
  "productServer.orderName": "Nom du produit",
  "productServer.leaseInfo": "Info de location",
  "productServer.leaseDate": "Date de location",
  "productServer.rent": "Loyer",
  "productServer.maintenanceFee": "Frais de maintenance",
  "productServer.profitInfo": "Info de revenu",
  "productServer.estimatedLeaseIncome": "Revenu de location total estimé",
  "productServer.settledIncome": "Revenu réglé",
  "productServer.phase": "{count} phase",
  "productServer.currentPhase": "Phase actuelle",
  "productServer.remark": "Remarque",
  "productServer.close": "Fermer",

  // ===== Inscription / Demande de qualification =====
  "register.back": "Retour à la connexion",
  "register.statusBadge": "Demande de qualification · Examen manuel",
  "register.title": "Demander une qualification",
  "register.subtitle":
    "Après soumission de vos informations, nous terminerons l'examen dans les 24 heures et vous enverrons une notification par e-mail",
  "register.basicInfo": "Informations de base",
  "register.firstNamePlaceholder": "Entrez votre prénom",
  "register.lastNamePlaceholder": "Entrez votre nom",
  "register.genderMale": "Masculin",
  "register.genderFemale": "Féminin",
  "register.genderSecret": "Non précisé",
  "register.birthdayPlaceholder": "Sélectionnez la date de naissance",
  "register.contactInfo": "Informations de contact",
  "register.emailPlaceholder": "Entrez votre e-mail",
  "register.phonePlaceholder": "Entrez votre numéro de téléphone",
  "register.telegramPlaceholder": "Entrez votre identifiant Telegram",
  "register.qualificationInfo": "Informations de qualification",
  "register.qualificationPlaceholder":
    "Décrivez votre expérience et vos besoins en puissance de calcul",
  "register.submit": "Soumettre la demande",
  "register.submitting": "Soumission...",
  "register.success": "Demande soumise avec succès !",
  "register.fail": "Échec de la soumission",
  "register.enterFirstName": "Veuillez entrer votre prénom",
  "register.enterLastName": "Veuillez entrer votre nom",
  "register.enterEmail": "Veuillez entrer votre e-mail",
  "register.enterPhone": "Veuillez entrer votre numéro de téléphone",
  "register.enterQualification":
    "Veuillez décrire votre expérience et vos besoins en puissance de calcul",

  // ===== Page de connexion =====
  "login.title": "Connexion",
  "login.subtitle": "Connectez-vous à votre compte",
  "login.email": "E-mail",
  "login.emailPlaceholder": "Entrez votre e-mail",
  "login.password": "Mot de passe",
  "login.passwordPlaceholder": "Entrez votre mot de passe",
  "login.loginBtn": "Se connecter",
  "login.registerBtn": "S'inscrire",
  "login.forgotPwd": "Mot de passe oublié ?",
  "login.success": "Connexion réussie !",
  "login.fail": "Échec de la connexion",
  "login.enterEmail": "Veuillez entrer votre e-mail",
  "login.enterPassword": "Veuillez entrer votre mot de passe",

  // ===== Page de dépôt =====
  "depositPage.title": "Dépôt",
  "depositPage.subtitle": "Déposez des fonds sur votre compte",
  "depositPage.selectCoin": "Sélectionnez une pièce",
  "depositPage.selectNetwork": "Sélectionnez le réseau",
  "depositPage.address": "Adresse de dépôt",
  "depositPage.copy": "Copier",
  "depositPage.copySuccess": "Adresse copiée dans le presse-papiers",
  "depositPage.qrAlt": "Code QR de dépôt",
  "depositPage.scanTip": "Scannez le code QR pour déposer",
  "depositPage.methodOnline": "💳 Dépôt en ligne",
  "depositPage.coin": "Pièce",
  "depositPage.protocol": "Protocole",
  "depositPage.qrPlaceholder": "Aucun code QR disponible",
  "depositPage.copied": "✅",
  "depositPage.addressWarning":
    "⚠️ Prend en charge uniquement les transferts <strong>{coin}</strong> ({protocol}). N'envoyez pas d'autres actifs",
  "depositPage.amountPlaceholder": "Entrez le montant du dépôt (optionnel)",
  "depositPage.transferBtn": "🚀 J'ai transféré",
  "depositPage.emptyState": "👆 Veuillez sélectionner la pièce et le protocole",
  "depositPage.noticeTitle": "📋 Avis de dépôt",
  "depositPage.onlineCardName1": "Carte de crédit/débit",
  "depositPage.onlineCardDesc1": "Visa · Mastercard",
  "depositPage.onlineCardBtn1": "Payer →",
  "depositPage.onlineCardName2": "Virement bancaire",
  "depositPage.onlineCardDesc2": "Arrivée en 1-3 jours ouvrables",
  "depositPage.onlineCardBtn2": "Obtenir les informations →",
  "depositPage.onlineCardName3": "Paiement tiers",
  "depositPage.onlineCardDesc3": "Alipay · WeChat · Paypal",
  "depositPage.onlineCardBtn3": "Payer →",
  "depositPage.notice1Title": "Délai d'arrivée",
  "depositPage.notice1Desc":
    "Les dépôts en cryptomonnaie nécessitent une confirmation du réseau blockchain, généralement 10-30 minutes, selon la charge du réseau.",
  "depositPage.notice2Title": "Dépôt minimum",
  "depositPage.notice2Desc":
    "Le montant minimum de dépôt est de 0,001 BTC ou l'équivalent en d'autres pièces. Les montants inférieurs ne peuvent pas être crédités.",
  "depositPage.notice3Title": "Exigences de confirmation",
  "depositPage.notice3Desc":
    "BTC nécessite 3 confirmations réseau. ETH/TRX/USDT nécessite 12 confirmations avant d'être crédité sur votre solde de compte.",
  "depositPage.notice4Title": "Rappel de sécurité des actifs",
  "depositPage.notice4Desc":
    "Veuillez vérifier soigneusement l'adresse de dépôt et le type de protocole. Des opérations incorrectes peuvent entraîner une perte permanente d'actifs. La plateforme n'est pas responsable.",
  "depositPage.feeInfo": "💸 Frais : {fee}",
  "depositPage.amount": "Montant du dépôt",
  "depositPage.minAmount": "Montant minimum : {amount}",
  "depositPage.confirm": "Confirmer le dépôt",
  "depositPage.success": "Dépôt réussi !",
  "depositPage.fail": "Échec du dépôt",
  "depositPage.enterAmount": "Veuillez entrer le montant du dépôt",
  "depositPage.amountTooSmall": "Le montant du dépôt est trop petit",
  "depositPage.loading": "Chargement...",
  "depositPage.empty": "Aucune pièce disponible",

  // ===== Page de retrait =====
  "withdrawPage.title": "Retrait",
  "withdrawPage.subtitle": "Retirez des fonds de votre compte",
  "withdrawPage.selectCoin": "Sélectionnez une pièce",
  "withdrawPage.selectNetwork": "Sélectionnez le réseau",
  "withdrawPage.address": "Adresse de retrait",
  "withdrawPage.addressPlaceholder": "Entrez l'adresse de retrait",
  "withdrawPage.amount": "Montant du retrait",
  "withdrawPage.amountPlaceholder": "Entrez le montant du retrait",
  "withdrawPage.available": "Disponible : {amount}",
  "withdrawPage.minAmount": "Montant minimum : {amount}",
  "withdrawPage.maxAmount": "Montant maximum : {amount}",
  "withdrawPage.fee": "Frais de retrait : {amount}",
  "withdrawPage.confirm": "Confirmer le retrait",
  "withdrawPage.success": "Retrait réussi !",
  "withdrawPage.fail": "Échec du retrait",
  "withdrawPage.enterAddress": "Veuillez entrer l'adresse de retrait",
  "withdrawPage.enterAmount": "Veuillez entrer le montant du retrait",
  "withdrawPage.amountTooSmall": "Le montant du retrait est trop petit",
  "withdrawPage.amountTooLarge": "Le montant du retrait est trop grand",
  "withdrawPage.loading": "Chargement...",
  "withdrawPage.empty": "Aucune pièce disponible",

  // ===== Page de liaison d'adresse =====
  "bindAddress.title": "🔗 Lier une adresse de portefeuille",
  "bindAddress.desc":
    "Liez votre adresse de portefeuille cryptographique pour les retraits",
  "bindAddress.cardTitle": "➕ Lier un nouveau portefeuille",
  "bindAddress.selectCoin": "Sélectionnez une pièce",
  "bindAddress.selectProtocol": "Sélectionnez le protocole",
  "bindAddress.walletAddress": "Adresse du portefeuille",
  "bindAddress.walletAddressPlaceholder": "Entrez l'adresse du portefeuille",
  "bindAddress.emailCode": "Code e-mail",
  "bindAddress.emailCodePlaceholder": "Entrez le code de vérification e-mail",
  "bindAddress.resend": "Renvoyer dans {count}s",
  "bindAddress.sendCode": "Envoyer le code",
  "bindAddress.confirmBind": "🔗 Confirmer la liaison",
  "bindAddress.noticeTitle": "📋 Avis de liaison",
  "bindAddress.twoFactorDesc":
    "Entrez votre code 2FA pour envoyer le code de vérification e-mail",
  "bindAddress.notice1Title": "Sécurité des actifs",
  "bindAddress.notice1Desc":
    "Veuillez vous assurer que l'adresse de portefeuille que vous liez vous appartient et conservez la clé privée en toute sécurité.",
  "bindAddress.notice2Title": "Restriction de retrait",
  "bindAddress.notice2Desc":
    "Aucun retrait n'est autorisé dans les 24 heures suivant la liaison, afin de protéger la sécurité des actifs du compte.",
  "bindAddress.notice3Title": "Vérification e-mail",
  "bindAddress.notice3Desc":
    "Chaque nouvelle liaison de portefeuille nécessite une confirmation par code de vérification e-mail.",
  "bindAddress.notice4Title": "Vérification de l'adresse",
  "bindAddress.notice4Desc":
    "Veuillez vérifier soigneusement l'adresse du portefeuille. Une liaison incorrecte peut entraîner l'impossibilité de récupérer les actifs.",
  "bindAddress.msgAddressInvalid":
    "⚠️ Veuillez d'abord entrer une adresse de portefeuille valide",
  "bindAddress.msgCodeError": "Erreur de code de vérification",
  "bindAddress.msgFormInvalid":
    "Veuillez remplir toutes les informations et obtenir le code de vérification e-mail",
  "bindAddress.subtitle": "Liez votre adresse de retrait",
  "bindAddress.coin": "Pièce",
  "bindAddress.network": "Réseau",
  "bindAddress.selectNetwork": "Sélectionnez le réseau",
  "bindAddress.address": "Adresse",
  "bindAddress.addressPlaceholder": "Entrez l'adresse",
  "bindAddress.save": "Enregistrer",
  "bindAddress.success": "Adresse liée avec succès !",
  "bindAddress.fail": "Échec de la liaison",
  "bindAddress.enterAddress": "Veuillez entrer l'adresse",
  "bindAddress.loading": "Chargement...",

  // ===== Page d'erreur =====
  "error.title": "Erreur",
  "error.desc": "Une erreur s'est produite",
  "error.back": "Retour à l'accueil",
  "error.backHome": "Retour à la page d'accueil",
  "error.refresh": "Actualiser",
  "error.footerTip":
    "Si le problème persiste, veuillez contacter le support technique",
  "error.title404": "Page non trouvée",
  "error.desc404":
    "La page que vous recherchez n'existe pas ou a été supprimée",

  // ===== Page de détails du serveur =====
  "detail.breadcrumbHome": "Accueil",
  "detail.breadcrumbRental": "Location de serveurs",
  "detail.breadcrumbDetail": "Détails",
  "detail.badgeHot": "🔥 Recommandation chaude",
  "detail.badgeAvailable": "✅ Disponible",
  "detail.badgeSold": "⏳ Complet",
  "detail.badgeEnded": "⏳ Terminé",
  "detail.badgePending": "⏳ Non démarré",
  "detail.code": "Code : ",
  "detail.specTitle": "Spécifications complètes",
  "detail.specGpu": "Modèle GPU",
  "detail.specVram": "VRAM",
  "detail.specStorage": "Stockage",
  "detail.specRam": "RAM",
  "detail.specBandwidth": "Bande passante",
  "detail.specValue": "Valeur du serveur",
  "detail.specCountry": "Pays",
  "detail.specCountryFlag": "Drapeau du pays",
  "detail.specStatus": "Statut",
  "detail.statusFull": "⏳ Complet",
  "detail.statusEnded": "⏳ Terminé",
  "detail.statusPending": "⏳ Non démarré",
  "detail.statusAvailable": "✅ Disponible",
  "detail.chartTitle": "Tendance des revenus",
  "detail.chartRealTime": "Temps réel",
  "detail.chartHint": "Cliquez pour agrandir",
  "detail.chart7d": "7J",
  "detail.chart15d": "15J",
  "detail.chart30d": "30J",
  "detail.statMax": "Max",
  "detail.statAvg": "Moyenne",
  "detail.statMin": "Min",
  "detail.statChange": "Variation",
  "detail.descTitle": "Description du produit",
  "detail.regionTitle": "Informations sur la région",
  "detail.panelTitle": "💎 Louer maintenant",
  "detail.statusDotFull": "● Complet",
  "detail.statusDotEnded": "● Terminé",
  "detail.statusDotPending": "● Non démarré",
  "detail.statusDotAvailable": "● Disponible",
  "detail.activityPeriod": "📅 Temps de cycle",
  "detail.daysLeft": "restants",
  "detail.days": "jours",
  "detail.subscribeShare": "🎚️ Part d'abonnement",
  "detail.customShare": "Part personnalisée",
  "detail.remainingShare": "Part restante",
  "detail.shareMsg":
    "Le ratio d'abonnement ne peut pas dépasser la valeur restante de {n}%",
  "detail.incomeDetail": "📈 Détails des revenus estimés",
  "detail.incomeTip":
    "Les revenus estimés sont fournis à titre de référence uniquement. Les revenus réels sont basés sur les données de règlement",
  "detail.estimate": "Estimation",
  "detail.rate": "Rendement :",
  "detail.settleDate": "Date de règlement :",
  "detail.moreStages": "{count} phases supplémentaires",
  "detail.hoverExpand": "Survolez pour agrandir",
  "detail.totalIncome": "Revenu total estimé",
  "detail.fundDetail": "💰 Détails du fonds",
  "detail.rentalAmount": "Montant de la location",
  "detail.maintenanceFee": "Frais de maintenance",
  "detail.feeFormula": "Valeur totale*{percent}%*{fee}%",
  "detail.tierDiscount": "Remise par palier",
  "detail.subscribeTip": "(Part {percent}%)",
  "detail.discountDetail": "🎯 Détails des paliers de remise",
  "detail.subscribeGte": "Part ≥ {percent}%",
  "detail.currentSubscribe": "Part actuelle {percent}%, remise -${discount}",
  "detail.total": "Total",
  "detail.btnFull": "⏳ Complet",
  "detail.btnEnded": "⏳ Terminé",
  "detail.btnPending": "⏳ Non démarré",
  "detail.btnRent": "🚀 Louer maintenant",
  "detail.btnOutOfStock": "⏳ Temporairement épuisé",
  "detail.guaranteeSupport": "Support client 7×24",
  "detail.guaranteeData": "Sécurité des données",
  "detail.guaranteeSla": "SLA 99,9%",
  "detail.recommendBadge": "🔄 Vous pourriez aussi aimer",
  "detail.recommendTitle1": "Recommandé",
  "detail.recommendTitle2": "Serveurs",
  "detail.recValue": "Valeur",
  "detail.recDetail": "Voir les détails →",
  "detail.faqBadge": "❓ FAQ",
  "detail.faqTitle1": "Location",
  "detail.faqTitle2": "FAQ",
  "detail.chartModalTitle": "📈 Graphique de tendance des revenus",
  "detail.spec0": "Entrée de gamme",
  "detail.spec1": "Léger",
  "detail.spec2": "Performance",
  "detail.spec3": "Flagship",
  "detail.spec4": "Ultra-flagship",
  "detail.faq1Q": "Ai-je besoin d'un dépôt de garantie pour louer un serveur ?",
  "detail.faq1A":
    "Pour les nouveaux utilisateurs, nous pouvons exiger un certain pourcentage de dépôt de garantie. Les partenaires à long terme peuvent bénéficier de réductions sur le dépôt. Le montant spécifique est basé sur la page de règlement.",
  "detail.faq2Q": "Comment renouveler après l'expiration de la location ?",
  "detail.faq2A":
    "Vous pouvez renouveler sur la page 'Mes locations' dans la console. Prend en charge le renouvellement quotidien, hebdomadaire, mensuel et trimestriel au même prix que la location actuelle.",
  "detail.faq3Q": "Que se passe-t-il si le serveur rencontre une panne ?",
  "detail.faq3A":
    "Nous fournissons un support technique 7×24. En cas de panne matérielle, nous répondons dans les 2 heures et terminons la réparation ou le remplacement dans les 24 heures.",
  "detail.faq4Q": "Puis-je mettre fin à la location à l'avance ?",
  "detail.faq4A":
    "Oui. En cas de résiliation anticipée, une pénalité de 30% de la durée de location restante est à payer. Veuillez lire attentivement l'« Accord de service de location » lors de la location.",
  "detail.faq5Q":
    "Comment la sécurité des données des serveurs loués est-elle garantie ?",
  "detail.faq5A":
    "Nous utilisons un chiffrement d'entreprise. Toutes les données sont chiffrées pendant la transmission et le stockage. Après la fin de la location, vos données sont entièrement supprimées.",
  "detail.unitWan": "K",
  "detail.msgOutOfStock": "Ce serveur est temporairement épuisé",
  "detail.msgSelectShare": "Veuillez sélectionner une part d'abonnement",
  "detail.msgRentFail": "Échec de la location",
  "detail.msgRentSuccess": "Location réussie",
  "detail.msgContact": "Contacter le support : 400-888-8888",
  "detail.pwdTitle": "Confirmation de location",
  "detail.pwdLabel": "Entrez le mot de passe de trading",
  "detail.pwdPlaceholder": "Entrez le mot de passe de trading",
  "detail.pwdConfirm": "Confirmer la location",
  "detail.pwdCancel": "Annuler",
  "detail.rentNow": "💎 Louer maintenant",
  "detail.rentAmount": "Montant de la location",
  "detail.subscribe": "Souscrire",
  "detail.descProduct": "Description du produit",
  "detail.descRegion": "Informations sur la région",
  "detail.rentNowBtn": "🚀 Louer maintenant",
  "detail.outOfStock": "⏳ Temporairement en rupture de stock",
  "detail.stages": "Étapes",
  "detail.discount": "Remise",
  "detail.rentConfirm": "Confirmer la location",
  "detail.enterPassword": "Veuillez saisir le mot de passe de transaction",
  "detail.confirmRent": "Confirmer la location",
  "detail.cancel": "Annuler",
  "detail.outOfStockMsg": "Ce serveur est temporairement en rupture de stock",
  "detail.selectShareMsg": "Veuillez sélectionner une part",
  "detail.rentFail": "Échec de la location",
  "detail.rentSuccess": "Location réussie",
  "detail.contactService": "Contactez le support : 400-888-8888",
  "detail.tenThousand": "万",

  // ===== Page d'informations sur la puissance de calcul =====
  "info.emptyTitle": "Aucun serveur de puissance de calcul disponible",
  "info.emptyDesc":
    "Bientôt disponible. Nous travaillons dur pour préparer plus de ressources de puissance de calcul de haute qualité pour vous",
  "info.collapse": "Réduire",
  "info.expand": "Agrandir",
  "info.collapseDetail": "Réduire les détails",
  "info.expandDetail": "Agrandir les détails",
  "info.priceTrend": "📈 Tendance des prix",
  "info.unit": "Unité",
  "info.latestPrice": "Prix actuel",
  "info.lastPrice": "Prix d'hier",
  "info.increase": "Augmentation",
  "info.buyNow": "Acheter maintenant",
  "info.buyCompute": "Acheter de la puissance de calcul",
  "info.selectPeriod": "Sélectionner la période",
  "info.day": "jours",
  "info.periodTime": "Période",
  "info.purchaseQuantity": "Quantité d'achat",
  "info.expectedProfit": "Revenu estimé",
  "info.profitTip":
    "Le revenu estimé est basé sur les moyennes historiques. Le revenu réel est basé sur les données de règlement",
  "info.baseProfit": "Revenu de base",
  "info.settle24h": "Règlement 24h",
  "info.periodProfit": "Revenu de période",
  "info.settleDue": "Règlement dû",
  "info.totalProfit": "Revenu total",
  "info.fundDetail": "Détails du fonds",
  "info.purchaseAmount": "Montant d'achat",
  "info.buyFormula": "Prix actuel x Quantité",
  "info.fee": "Frais",
  "info.feeFormula": "Montant d'achat*{fee}%",
  "info.total": "Total",
  "info.cancel": "Annuler",
  "info.confirmBuy": "Confirmer l'achat",
  "info.tradeConfirm": "Confirmation de transaction",
  "info.enterPassword": "Entrez le mot de passe de trading",
  "info.confirmPay": "Confirmer le paiement",
  "info.chart7d": "7J",
  "info.chart15d": "15J",
  "info.chart30d": "30J",
  "info.price": "Prix",
  "info.maxValue": "Valeur maximale",
  "info.noData": "Aucune donnée",
  "info.fetchFail": "Échec de la récupération des données",
  "info.selectProduct": "Veuillez d'abord sélectionner un produit",
  "info.quantityMin": "La quantité d'achat ne peut pas être inférieure à 1",
  "info.priceError": "Le prix actuel est anormal, veuillez réessayer plus tard",
  "info.buySuccess": "Achat réussi !",
  "info.tradeFail": "Échec de la transaction, veuillez réessayer plus tard",
  "info.passwordError": "Mot de passe de trading incorrect, veuillez réessayer",
  "info.buyFail": "Échec de l'achat, veuillez réessayer plus tard",

  // ===== Page À propos de nous =====
  "about.tocTitle": "📑 Table des matières",
  "about.toc1": "Maîtriser l'or numérique",
  "about.toc2": "Matrice de produits de base",
  "about.toc3": "Sécurité et fiabilité Aetrivol",
  "about.toc4": "Valeur d'investissement",
  "about.section1Title":
    "Maîtriser l'or numérique : devenez le « Seigneur de la nouvelle puissance de calcul » de l'ère intelligente",
  "about.section1P1":
    "Alors que les modèles mondiaux entrent dans des batailles de milliards de paramètres et que l'intelligence incarnée explose complètement, la puissance de calcul a complètement remplacé le pétrole comme monnaie forte ultime qui domine la richesse mondiale. Les géants de la technologie thésaurisent les GPU à tout prix, et les centres de données coûtant des centaines de millions excluent les investisseurs ordinaires. Aetrivol est né pour répondre aux exigences de l'époque. Grâce à notre mécanisme innovant d'ancrage de la puissance de calcul et à notre modèle de location de serveurs de puissance de calcul, nous brisons les monopoles de richesse et vous permettent de participer directement à la plus grande fête de création de richesse de l'histoire de l'humanité de la manière la plus simple et la plus flexible.",
  "about.section2Title":
    "Matrice de produits de base : moteur de richesse à double entraînement",
  "about.section2H1":
    "Produit innovant 1 : [Valeur de puissance de calcul (CV)] — « Dividendes tokenisés » des actifs de puissance de calcul mondiaux",
  "about.section2P1":
    "· Briser les barrières, micro-assetisation : nous standardisons et partageons la puissance de calcul totale des centres de données physiques mondiaux et des serveurs GPU haut de gamme (NVIDIA Blackwell, Huawei Ascend, etc.). 1 point de [Valeur de puissance de calcul] représente votre propriété d'une part spécifique de la puissance de calcul dans le réseau de calcul mondial.",
  "about.section2P2":
    "· Acheter des GPU comme un fonds : avec un petit investissement minimum pour souscrire à la [Valeur de puissance de calcul], vous pouvez briser la barrière « difficile d'obtenir une carte ». Votre valeur de puissance de calcul fonctionne 24/7 sur la plateforme et génère quotidiennement des dividendes de flux de trésorerie numériques provenant des grands modèles d'IA et des appels d'agents dans le monde entier.",
  "about.section2P3":
    "· Haute liquidité, encaissable à tout moment : la valeur de puissance de calcul a une liquidité d'actifs extrêmement forte. Avec la demande mondiale croissante de puissance de calcul, la valeur de puissance de calcul elle-même a un fort potentiel d'appréciation. Vous pouvez négocier et encaisser à tout moment sur la plateforme.",
  "about.section2H2":
    "Activité principale 2 : [Location de serveurs de puissance de calcul] — Le modèle stable à long terme de « propriétaire numérique »",
  "about.section2P4":
    "· Souscription d'actifs physiques, propriété exclusive du serveur : les investisseurs peuvent directement souscrire des serveurs entiers ou des racks standard de serveurs de puissance de calcul sous la plateforme. Chaque serveur est mappé sur la chaîne avec un numéro SN physique unique.",
  "about.section2P5":
    "· Location gérée à long terme, loyer élevé stable : après la souscription, les serveurs sont directement hébergés dans les centres de données de premier plan de la plateforme dans les hubs mondiaux de puissance de calcul verte (tels que les nœuds de calcul ouest-est de la Chine, l'Europe du Nord, le Moyen-Orient, etc.). La plateforme loue vos serveurs aux développeurs de grands modèles, aux instituts de recherche universitaires ou aux entreprises d'IA verticales qui ont besoin de puissance de calcul, garantissant des rendements élevés stables sur 3 à 5 ans.",
  "about.section3Title":
    "Pourquoi Aetrivol peut-il transformer le risque en sécurité absolue ?",
  "about.section3P1":
    "· Ancrage à 100% des actifs physiques sur la chaîne : nous rejetons les châteaux en l'air. Que ce soit la valeur de puissance de calcul que vous détenez ou les serveurs que vous louez, ils sont tous mappés en temps réel sur la chaîne vers du matériel accélérateur physique qui est en ligne et fonctionne. Les actifs sont visibles, tangibles et vérifiables.",
  "about.section3P2":
    "· Efficacité énergétique de premier ordre et double assurance « anti-géopolitique » : les centres de données que nous emballons sont équipés à 100% d'« alimentation directe micro-nucléaire (SMR)/solaire » ou sont situés dans des juridictions absolument sûres sans conflit, évitant complètement les risques de tsunamis de réseau locaux mondiaux et de fluctuations géopolitiques.",
  "about.section3P3":
    "· Approbation de crédit des géants et garantie de contrat à long terme : la plateforme privilégie les sites matures pré-réservés pour la location par les géants de l'IA comme Microsoft, OpenAI et DeepSeek, utilisant la crédibilité des géants de la technologie comme approbation de vos rendements.",
  "about.section4Title":
    "Autrefois, ils investissaient dans la terre et le pétrole ; aujourd'hui, nous investissons dans la puissance de calcul.",
  "about.section4P1":
    "Alors que toute la sagesse humaine et les affaires migrent vers le monde numérique, la puissance de calcul est le seul matériau de construction de ce nouveau monde. Rejoignez Aetrivol, achetez votre valeur de puissance de calcul et lancez votre voyage de location de serveurs de puissance de calcul. Transformez votre capital en atomes de puissance de calcul qui remodèlent le monde et partagez cette montée de richesse de l'explosion intelligente !",

  phase: "Phase",

  // fr-fr 法语
  country: {
    1: "États-Unis",
    2: "Chine",
    3: "Japon",
    4: "Corée du Sud",
    5: "Allemagne",
    6: "Royaume-Uni",
    7: "France",
    8: "Émirats arabes unis",
    9: "Singapour",
    10: "Israël",
    11: "Russie",
    12: "Inde",
    13: "Brésil",
    14: "Italie",
    15: "Espagne",
    16: "Portugal",
    17: "Pays-Bas",
    18: "Belgique",
    19: "Suisse",
    20: "Suède",
    21: "Norvège",
    22: "Finlande",
    23: "Danemark",
    24: "Islande",
    25: "Irlande",
    26: "Autriche",
    27: "Pologne",
    28: "République tchèque",
    29: "Hongrie",
    30: "Grèce",
    31: "Ukraine",
    32: "Biélorussie",
    33: "Roumanie",
    34: "Bulgarie",
    35: "Serbie",
    36: "Croatie",
    37: "Albanie",
    38: "Estonie",
    39: "Lettonie",
    40: "Lituanie",
    41: "Moldavie",
    42: "Slovaquie",
    43: "Slovénie",
    44: "Bosnie-Herzégovine",
    45: "Monténégro",
    46: "Macédoine du Nord",
    47: "Luxembourg",
    48: "Malte",
    49: "Andorre",
    50: "Monaco",
    51: "Liechtenstein",
    52: "Saint-Marin",
    53: "Vatican",
    54: "Canada",
    55: "Mexique",
    56: "Cuba",
    57: "Guatemala",
    58: "Honduras",
    59: "Nicaragua",
    60: "Costa Rica",
    61: "Panama",
    62: "Jamaïque",
    63: "Haïti",
    64: "République dominicaine",
    65: "Trinité-et-Tobago",
    66: "Dominique",
    67: "Sainte-Lucie",
    68: "Saint-Vincent-et-les-Grenadines",
    69: "Grenade",
    70: "Saint-Christophe-et-Niévès",
    71: "Antigua-et-Barbuda",
    72: "Bahamas",
    73: "Barbade",
    74: "Belize",
    75: "Salvador",
    76: "Argentine",
    77: "Colombie",
    78: "Venezuela",
    79: "Pérou",
    80: "Chili",
    81: "Équateur",
    82: "Bolivie",
    83: "Paraguay",
    84: "Uruguay",
    85: "Guyana",
    86: "Suriname",
    87: "Australie",
    88: "Nouvelle-Zélande",
    89: "Papouasie-Nouvelle-Guinée",
    90: "Fidji",
    91: "Îles Salomon",
    92: "Vanuatu",
    93: "Samoa",
    94: "Kiribati",
    95: "Micronésie",
    96: "Îles Marshall",
    97: "Palaos",
    98: "Nauru",
    99: "Tuvalu",
    100: "Tonga",
    101: "Îles Cook",
    102: "Niue",
    103: "Égypte",
    104: "Afrique du Sud",
    105: "Nigeria",
    106: "Éthiopie",
    107: "Kenya",
    108: "Tanzanie",
    109: "Algérie",
    110: "Maroc",
    111: "Soudan",
    112: "Soudan du Sud",
    113: "Ghana",
    114: "Angola",
    115: "Mozambique",
    116: "Madagascar",
    117: "Cameroun",
    118: "Côte d'Ivoire",
    119: "Niger",
    120: "Burkina Faso",
    121: "Mali",
    122: "Sénégal",
    123: "Ouganda",
    124: "Zambie",
    125: "Zimbabwe",
    126: "Tchad",
    127: "Congo",
    128: "République démocratique du Congo",
    129: "Gabon",
    130: "Botswana",
    131: "Namibie",
    132: "Maurice",
    133: "Rwanda",
    134: "Somalie",
    135: "Djibouti",
    136: "Érythrée",
    137: "Libye",
    138: "Tunisie",
    139: "Sierra Leone",
    140: "Liberia",
    141: "Togo",
    142: "Bénin",
    143: "Guinée",
    144: "Guinée-Bissau",
    145: "Gambie",
    146: "Cap-Vert",
    147: "Sao Tomé-et-Principe",
    148: "Guinée équatoriale",
    149: "Mauritanie",
    150: "Eswatini",
    151: "Lesotho",
    152: "Malawi",
    153: "République centrafricaine",
    154: "Burundi",
    155: "Comores",
    156: "Seychelles",
    157: "Turquie",
    158: "Iran",
    159: "Irak",
    160: "Arabie saoudite",
    161: "Mongolie",
    162: "Corée du Nord",
    163: "Indonésie",
    164: "Philippines",
    165: "Viêt Nam",
    166: "Thaïlande",
    167: "Malaisie",
    168: "Birmanie",
    169: "Cambodge",
    170: "Laos",
    171: "Brunei",
    172: "Timor oriental",
    173: "Pakistan",
    174: "Bangladesh",
    175: "Népal",
    176: "Bhoutan",
    177: "Sri Lanka",
    178: "Maldives",
    179: "Kazakhstan",
    180: "Ouzbékistan",
    181: "Turkménistan",
    182: "Kirghizistan",
    183: "Tadjikistan",
    184: "Afghanistan",
    185: "Syrie",
    186: "Jordanie",
    187: "Liban",
    188: "Palestine",
    189: "Oman",
    190: "Yémen",
    191: "Koweït",
    192: "Qatar",
    193: "Bahreïn",
    194: "Géorgie",
    195: "Arménie",
    196: "Azerbaïdjan",
    197: "Chypre",
  },

  token: {
    us: {
      content: {
        title: "",
        content: usContent.content,
      },
      t1: {
        title: "Statut actuel",
        content: usContent.t1,
      },
      t2: {
        title: "Avantages clés",
        content: usContent.t2,
      },
      t3: {
        title: "Défis",
        content: usContent.t3,
      },
      t4: {
        title: "Tendances futures",
        content: usContent.t4,
      },
    },
    cn: {
      content: {
        title: "",
        content: cnContent.content,
      },
      t1: {
        title: "Statut actuel",
        content: cnContent.t1,
      },
      t2: {
        title: "Avantages clés",
        content: cnContent.t2,
      },
      t3: {
        title: "Défis",
        content: cnContent.t3,
      },
      t4: {
        title: "Tendances futures",
        content: cnContent.t4,
      },
    },
    jp: {
      content: {
        title: "",
        content: jpContent.content,
      },
      t1: {
        title: "Statut actuel",
        content: jpContent.t1,
      },
      t2: {
        title: "Avantages clés",
        content: jpContent.t2,
      },
      t3: {
        title: "Défis",
        content: jpContent.t3,
      },
      t4: {
        title: "Tendances futures",
        content: jpContent.t4,
      },
    },
    ko: {
      content: {
        title: "",
        content: koContent.content,
      },
      t1: {
        title: "Statut actuel",
        content: koContent.t1,
      },
      t2: {
        title: "Avantages clés",
        content: koContent.t2,
      },
      t3: {
        title: "Défis",
        content: koContent.t3,
      },
      t4: {
        title: "Tendances futures",
        content: koContent.t4,
      },
    },
    ge: {
      content: {
        title: "",
        content: geContent.content,
      },
      t1: {
        title: "Statut actuel",
        content: geContent.t1,
      },
      t2: {
        title: "Avantages clés",
        content: geContent.t2,
      },
      t3: {
        title: "Défis",
        content: geContent.t3,
      },
      t4: {
        title: "Tendances futures",
        content: geContent.t4,
      },
    },
    uk: {
      content: {
        title: "",
        content: ukContent.content,
      },
      t1: {
        title: "Statut actuel",
        content: ukContent.t1,
      },
      t2: {
        title: "Avantages clés",
        content: ukContent.t2,
      },
      t3: {
        title: "Défis",
        content: ukContent.t3,
      },
      t4: {
        title: "Tendances futures",
        content: ukContent.t4,
      },
    },
    fr: {
      content: {
        title: "",
        content: frContent.content,
      },
      t1: {
        title: "Statut actuel",
        content: frContent.t1,
      },
      t2: {
        title: "Avantages clés",
        content: frContent.t2,
      },
      t3: {
        title: "Défis",
        content: frContent.t3,
      },
      t4: {
        title: "Tendances futures",
        content: frContent.t4,
      },
    },
    uae: {
      content: {
        title: "",
        content: uaeContent.content,
      },
      t1: {
        title: "Statut actuel",
        content: uaeContent.t1,
      },
      t2: {
        title: "Avantages clés",
        content: uaeContent.t2,
      },
      t3: {
        title: "Défis",
        content: uaeContent.t3,
      },
      t4: {
        title: "Tendances futures",
        content: uaeContent.t4,
      },
    },
    sg: {
      content: {
        title: "",
        content: sgContent.content,
      },
      t1: {
        title: "Statut actuel",
        content: sgContent.t1,
      },
      t2: {
        title: "Avantages clés",
        content: sgContent.t2,
      },
      t3: {
        title: "Défis",
        content: sgContent.t3,
      },
      t4: {
        title: "Tendances futures",
        content: sgContent.t4,
      },
    },
  },

  agreement: agreementContent,

  "withdraw.insufficientHandlingFee": "Frais de traitement insuffisants",
  "withdraw.twoFactor":
    "Vous n'avez pas activé l'authentification à deux facteurs, vous ne pouvez pas retirer. Veuillez d'abord activer l'authentification à deux facteurs.",
  "bindAddress.twoFactor":
    "Vous n'avez pas activé l'authentification à deux facteurs, vous ne pouvez pas lier l'adresse. Veuillez d'abord activer l'authentification à deux facteurs.",
  "productServer.statusPending": "En attente d'exécution",
};
